<div class="panel">
  <span class="label">{{ title }}</span>
  <ion-datetime-button class="value" [datetime]="pickerId" [disabled]="disabled"></ion-datetime-button>
</div>

<ion-modal
  id="pickerModal"
  [initialBreakpoint]="1" 
  [breakpoints]="[0, 1]"
  [handle]="false"
  [canDismiss]="canDismiss"
  [keepContentsMounted]="true"
>
  <ng-template>
    <div class="picker">
      <ion-datetime
        [id]="pickerId"
        [value]="value | formatToLocal"
        presentation="time"
        [preferWheel]="true"
        hourCycle="h12"
        mode="ios"
      ></ion-datetime>

      <div class="button" (click)="onApply()">Set</div>
    </div>
  </ng-template>
</ion-modal>